import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceRequestServiceOrder from './ServiceRequestServiceOrder'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'service-order/list',
    name:
      'serviceRequest.service-order.list',
    component: ServiceRequestServiceOrder,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
